import { render } from "./Services.vue?vue&type=template&id=21213866&scoped=true"
const script = {}

import "./Services.vue?vue&type=style&index=0&id=21213866&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21213866"]])

export default __exports__